const faq = {
  // HeroSection
  'faq.hero.homeLink': 'ホーム',
  'faq.hero.currentPage': 'よくある質問',
  'faq.hero.title': 'よくあるご質問',
  'faq.hero.titleEn': 'FAQ',
  'faq.hero.lead': '受講に関するよくある質問をカテゴリ別にまとめました。執事になるにはどうすればよいか、学費や課程の期間、女性の受講可否など、執事の技能を基礎から学べる執事学校への入学前によくいただく疑問も掲載しています。解決しない場合はお問い合わせフォームよりお気軽にご連絡ください。',
  'faq.hero.imgAlt': '質問に丁寧に答える講師と向き合って相談する受講生の様子',

  // Categories
  'faq.category.0': 'コース全般',
  'faq.category.1': '受講料・支払い',
  'faq.category.2': '入学・申込',
  'faq.category.3': '体験講座',
  'faq.category.4': '法人研修',
  'faq.category.5': 'アクセス・設備',

  // Category 0: コース全般
  'faq.cat0.0.question': '未経験でも受講できますか？',
  'faq.cat0.0.answer': 'はい。日本執事アカデミーの全コースは未経験者を歓迎しています。エッセンシャルコースでは基礎の所作から段階的に学べるカリキュラムを採用しており、18歳以上であれば国籍・性別・経験を問わず受講いただけます。',
  'faq.cat0.1.question': '執事の資格は取得できますか？',
  'faq.cat0.1.answer': '各コースの修了実技試験に合格すると、一般社団法人全日本執事協会が認定する民間資格（認定アソシエイトバトラー／認定プロフェッショナルバトラー／認定マスターバトラー）と認定ピンバッジを授与します。※当資格は一般社団法人全日本執事協会が独自に認定する民間資格です。',
  'faq.cat0.2.question': 'コースの違いは何ですか？',
  'faq.cat0.2.answer': 'エッセンシャルコース（1ヶ月・8日間・48時間）は初心者向けの入門課程、アドバンスコース（2ヶ月・12日間・72時間）はエッセンシャルの内容を含めてワインサービスやイベント運営まで学ぶ中級課程、マスターコース（3ヶ月・16日間・96時間）はエッセンシャル・アドバンスの内容を含めて管理能力・危機対応までを修める最上級課程です。\n\nどのコースも単体で完結しており、目的に応じて1コースをお選びいただけます。エッセンシャル修了者はアドバンスへ80,000円引、アドバンス修了者はマスターへ180,000円引で、重複内容分を編入優遇として減額いたします。日本の執事学校の課程は8日間48時間から3ヶ月96時間まで選べ、期間の目安としてご参照ください。',
  'faq.cat0.3.question': '仕事をしながら受講できますか？',
  'faq.cat0.3.answer': 'はい。全コースを土日開催としており、平日にお勤めの方でも無理なく通学いただけます。1日の授業時間は10:00〜17:15（90分×4コマ＋昼食休憩）です。',
  'faq.cat0.4.question': '定員は何人ですか？',
  'faq.cat0.4.answer': '完全少人数制で定員は6名です。最少催行人数は3名で、開校14日前に3名未満の場合は全額返金または次期振替＋5%優待を選択いただけます。先着順での受付となります。',

  // Category 1: 受講料・支払い
  'faq.cat1.0.question': '受講料はいくらですか？',
  'faq.cat1.0.answer': 'エッセンシャルコース：780,000円（税込）／アドバンスコース：1,180,000円（税込）／マスターコース：1,680,000円（税込）です。いずれも教材費・実習費・特典・認定試験料を含みます。日本の執事学校としての受講料はコース別に設定しており、学費の詳細は料金ページでもご案内しています。',
  'faq.cat1.1.question': '支払い方法を教えてください。',
  'faq.cat1.1.answer': '銀行振込による一括払いのみとなります。分割払い・クレジットカードはご利用いただけません。振込手数料はお客様負担となります。お支払い期限は開校日の14日前です。',
  'faq.cat1.2.question': 'キャンセルした場合、返金されますか？',
  'faq.cat1.2.answer': '申込から8日以内かつ開校前であれば理由を問わず全額返金いたします。開校15日前まで：全額返金／14〜8日前：20%／7日前〜前日：50%／当日以降の中途解約：受講済み日数分＋未受講分の30%を申し受け残額を返金します。やむを得ない事由がある場合は次期への無償振替（1回限り）を選択いただけます。',

  // Category 2: 入学・申込
  'faq.cat2.0.question': '応募資格を教えてください。',
  'faq.cat2.0.answer': '18歳以上／国籍・性別・経験不問／日本語での授業受講に支障がないこと／実技実習が可能なこと／受講規約・服装規定に同意いただけること。以上の条件を満たす方であればどなたでもお申込みいただけます。',
  'faq.cat2.1.question': '入学までの流れを教えてください。',
  'faq.cat2.1.answer': '(1)資料請求（任意）→(2)個別相談（任意）→(3)申込フォームよりお申込み→(4)受講確定のご案内と事前準備資料をお送りします。資料請求・個別相談は必須ではありませんが、コース選びに迷われる場合はぜひご活用ください。',
  'faq.cat2.2.question': '服装の指定はありますか？',
  'faq.cat2.2.answer': '授業日は白シャツ・黒系のスラックスまたはスカート・革靴をお願いしています。白手袋は初日に当アカデミーからお渡しします。詳細はお申込み後にご案内いたします。',

  // Category 3: 体験講座
  'faq.cat3.0.question': '体験講座とは何ですか？',
  'faq.cat3.0.answer': '「執事の作法・入門」と題した1日6時間の体験プログラムです。受講料は33,000円（税込）で、定員6名・最少催行2名、年6回程度の開催です。白手袋を着けて本物の執事教育の一端を体験いただけます。',
  'faq.cat3.1.question': '体験講座の参加費は本科に充当されますか？',
  'faq.cat3.1.answer': 'はい。体験講座の参加費33,000円（税込）は、ご参加から1年以内に本科（エッセンシャル・アドバンス・マスター）へお申込みいただく際に、受講料へ全額充当されます。',

  // Category 4: 法人研修
  'faq.cat4.0.question': '法人研修の料金体系を教えてください。',
  'faq.cat4.0.answer': '半日（3時間・2モジュール）220,000円／1日（6時間・4モジュール）330,000円／2日間パッケージ594,000円／開業前集中3日間891,000円／継続プログラム（月1回半日×6ヶ月）1,188,000円（すべて税込・全国出張対応・交通費宿泊費実費別）です。オプションで覆面サービス診断（165,000円〜）・教材カスタム開発（110,000円〜）も承ります。',
  'faq.cat4.1.question': '法人研修のキャンセル規定を教えてください。',
  'faq.cat4.1.answer': '実施7営業日前まで無償で日程変更が可能です。6営業日前〜前々日は料金の50%、前日・当日は100%を申し受けます。お支払いは請求書払い（銀行振込）で、実施日7営業日前までのお振込みをお願いしております。',
  'faq.cat4.2.question': 'どんな業種に対応していますか？',
  'faq.cat4.2.answer': 'ホテル・旅館、高級レジデンス（コンシェルジュ）、金融・プライベートバンク、百貨店外商・高級小売、ラグジュアリー営業（自動車・宝飾・不動産）、医療・美容クリニックなど、富裕層接点を持つあらゆる業種に対応します。業種別に研修モジュールと演習シナリオをカスタマイズいたします。',

  // Category 5: アクセス・設備
  'faq.cat5.0.question': 'アカデミーへの行き方を教えてください。',
  'faq.cat5.0.answer': '〒135-0064 東京都江東区青海2丁目7-4。ゆりかもめ「東京国際クルーズターミナル駅」または「テレコムセンター駅」より各徒歩約5分です。お車でお越しの際は近隣の有料駐車場をご利用ください。来校は完全予約制となっております。',
  'faq.cat5.1.question': '見学は可能ですか？',
  'faq.cat5.1.answer': '完全予約制にて個別相談を承っております。個別相談では施設見学も可能です。まずはお問い合わせフォームまたはお電話（03-6824-4086／平日10:00〜17:00）にてご予約ください。',

  // Contact section
  'faq.contact.label': 'CONTACT',
  'faq.contact.title': 'ご不明な点はお気軽に',
  'faq.contact.body': 'よくある質問で解決しない場合は、お問い合わせフォームよりご連絡ください。お電話でも承ります（03-6824-4086／平日10:00〜17:00）。',
  'faq.contact.formLink': 'お問い合わせフォームへ',
  'faq.contact.brochureLink': '資料請求はこちら（無料）',

  // RelatedPages
  'faq.related.label': 'LEARN MORE',
  'faq.related.title': '関連ページ',
  'faq.related.titleEn': 'Explore Further',
  'faq.related.viewLink': '詳しく見る',
  'faq.related.0.title': 'コース一覧',
  'faq.related.0.desc': '3つのコースを比較する',
  'faq.related.1.title': '入学案内',
  'faq.related.1.desc': 'お申込みまでの流れ',
  'faq.related.2.title': '体験講座',
  'faq.related.2.desc': '1日で執事教育を体験する',
  'faq.related.3.title': 'アクセス',
  'faq.related.3.desc': '東京・お台場の校舎へのご案内',

  // Last updated
  'faq.lastUpdated': '最終更新: 2026年7月8日',
};

export default faq;
